import type { ReactNode } from "react";

import {
  Badge,
  type BadgeProps,
  Button,
  type ButtonProps,
  Text,
} from "@alpacahq/ui/old";

import { cn } from "~/v2/utils/cn";

export const FeatureCard = ({
  title,
  badge,
  body,
  button,
  disclaimer,
}: {
  title: string;
  badge?: {
    variant: BadgeProps["variant"];
    text: string;
  };
  body?: string | ReactNode;
  button?: {
    onClick: ButtonProps["onClick"];
    text: string;
    disabled?: boolean;
  };
  disclaimer?: string | ReactNode;
}) => (
  <div className="grid w-full max-w-96 gap-4 rounded border border-gray-200 bg-white p-6">
    <div className="mb-4 flex items-start justify-between">
      <Text className="pr-2 font-bold text-base">{title}</Text>
      {badge && <Badge variant={badge.variant}>{badge.text}</Badge>}
    </div>

    <div className="flex items-start text-sm">{body}</div>

    <div className="overflow-clip">
      {button && (
        <Button
          variant="alternate"
          className={cn(
            button.disabled
              ? "w-full bg-gray-50"
              : "mt-4 w-full border-2 border-yellow-400",
          )}
          onClick={button.onClick}
          disabled={button.disabled}
        >
          {button.text}
        </Button>
      )}
      {disclaimer && <Text className="mt-2 text-xs">{disclaimer ?? ""}</Text>}
    </div>
  </div>
);
